import { Component, Input } from '@angular/core';
import { NgCollapsibleArrowSide, NgCollapsibleIconSet, NgCollapsibleOptions } from 'ng-collapsible';

@Component({
  selector: 'app-collapsible',
  templateUrl: './collapsible.component.html',
  styleUrls: ['./collapsible.component.scss'],
})
export class CollapsibleComponent {
  @Input() options: NgCollapsibleOptions = {
    showArrow: true,
    arrowSide: NgCollapsibleArrowSide.end,
    iconSet: NgCollapsibleIconSet.md,
  };
  @Input() isOpen: boolean = false;
}
